/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Prompt_Tips_One_Thing_DescInputs */

const es_prompt_tips_one_thing_desc = /** @type {(inputs: Prompt_Tips_One_Thing_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Si necesitás varias cosas, es mejor hacer consultas separadas. El agente trabaja mejor cuando tiene un objetivo claro y acotado.`)
};

const en_prompt_tips_one_thing_desc = /** @type {(inputs: Prompt_Tips_One_Thing_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`If you need several things, it's better to make separate queries. The agent works best when it has a clear, focused objective.`)
};

/**
* | output |
* | --- |
* | "If you need several things, it's better to make separate queries. The agent works best when it has a clear, focused objective." |
*
* @param {Prompt_Tips_One_Thing_DescInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const prompt_tips_one_thing_desc = /** @type {((inputs?: Prompt_Tips_One_Thing_DescInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Prompt_Tips_One_Thing_DescInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_prompt_tips_one_thing_desc(inputs)
	return en_prompt_tips_one_thing_desc(inputs)
});
export { prompt_tips_one_thing_desc as "prompt_tips.one_thing_desc" }